<div>
  <div class="action-info">
    <div class="info">
      <ng-container [ngSwitch]="snapshotStatus">
        <ng-container *ngSwitchCase="'active'">
          <span>
            {{ 'COMMON.CREATED' | translate }} {{ created | date: 'longDate' }}
          </span>
        </ng-container>

        <ng-container *ngSwitchCase="'expired'">
          <span>
            {{ 'COMMON.CREATED' | translate }} {{ created | date: 'longDate' }}
          </span>
          <span>({{ snapshotCreatedDaysAgo }})</span>
          <div class="button-info">
            <button
              mat-stroked-button
              (click)="refreshSnapshot()"
              [trackEvent]="{
                eventName: 'scorecard-refresh',
                category: trackingProperties?.category,
                properties: { snapshotId: trackingProperties?.snapshotId }
              }"
            >
              <mat-icon>refresh</mat-icon>
              {{ 'CTA.REFRESH_REPORT' | translate }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'outdated'">
          <span class="warning">
            {{ 'COMMON.CREATED' | translate }} {{ created | date: 'longDate' }}
          </span>
          <span class="warning">({{ snapshotCreatedDaysAgo }})</span>
          <div class="secondary-text">
            <span>
              {{
                'CTA.REFRESH_WARNING'
                  | translate: { snapshotName: snapshotName }
              }}
            </span>
          </div>
          <div class="button-info">
            <button
              mat-stroked-button
              (click)="refreshSnapshot()"
              [trackEvent]="{
                eventName: 'scorecard-refresh',
                category: trackingProperties?.category,
                properties: { snapshotId: trackingProperties?.snapshotId }
              }"
            >
              <mat-icon>refresh</mat-icon>
              {{ 'CTA.REFRESH_REPORT' | translate }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'unknown'">
          <div class="secondary-text">
            <span>
              {{
                'CTA.REFRESH_WARNING'
                  | translate: { snapshotName: snapshotName }
              }}
            </span>
          </div>
          <div class="button-info">
            <button
              mat-stroked-button
              (click)="refreshSnapshot()"
              [trackEvent]="{
                eventName: 'scorecard-refresh',
                category: trackingProperties?.category,
                properties: { snapshotId: trackingProperties?.snapshotId }
              }"
            >
              <mat-icon>refresh</mat-icon>
              {{ 'CTA.REFRESH_REPORT' | translate }}
            </button>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
